<template>
  <section class="section">
    <div class="section-body">
      <div class="card">
        <div class="card-header">
          <v-icon color="#28a745">mdi-file</v-icon>
          <h4>{{ $t("messages.general.showInfo") }}</h4>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-striped" id="table-epp1">
              <thead>
                <tr>
                  <th class="text-center">
                    No.
                  </th>
                  <th class="text-center">
                    TOR
                  </th>
                  <th class="text-center">
                    Name
                  </th>
                  <th class="text-center">
                    URL
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in listMenu" :key="index">
                  <td class="text-center">{{ index + 1 }}</td>
                  <td class="text-center">{{ item.tor }}</td>
                  <td>{{ item.name }}</td>
                  <td>
                    {{ item.url }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ListMenu",
  data() {
    return {
      listMenu: [
        {
          tor: "TOR1",
          name: "แจ้งความประสงค์ขอลงทะเบียนเรียน",
          url: "/reqRegister"
        },
        {
          tor: "TOR2",
          name: "ตรวจสอบรายวิชาที่ได้รับอนุมัติการแจ้งความประสงค์",
          url: "/chkResultRequest"
        },
        {
          tor: "TOR3",
          name: "ตรวจสอบผลการลงทะเบียนเรียนและประวัติการยืนยัน ",
          url: "/chkResultRegister"
        },
        { tor: "TOR4", name: "ลงทะเบียนเรียน", url: "/register" },
        {
          tor: "TOR5",
          name: "ตรวจสอบรายวิชาตามแผนการศึกษา",
          url: "/chkClassByPlan"
        },
        { tor: "TOR6", name: "ตรวจสอบรายวิชาที่เปิดสอน", url: "/chkOpenClass" },
        { tor: "TOR7", name: "ผลการลงทะเบียนเรียน", url: "/chkRegisterResult" },
        { tor: "TOR8", name: "พิมพ์ใบแจ้งยอด", url: "/printStatement" },
        {
          tor: "TOR9",
          name: "ตรวจสอบและปรับปรุงการแจ้งความประสงค์ขอลงทะเบียนเรียน",
          url: "/tor9"
        },
        {
          tor: "TOR10",
          name: "ยืนยันการลงทะเบียนเรียนให้นักศึกษา",
          url: "/tor10"
        },
        {
          tor: "TOR11",
          name: "ตรวจสอบผลการลงทะเบียนเรียนและประวัติการยืนยัน",
          url: "/tor11"
        },
        {
          tor: "TOR12",
          name: "ยืนยันการรับแจ้งความประสงค์ขอลงทะเบียนเรียน",
          url: "/tor12"
        },
        {
          tor: "TOR13",
          name: "อนุมัติ RANDOM การแจ้งความประสงค์ขอลงทะเบียนเรียน",
          url: "/tor13"
        },
        {
          tor: "TOR14",
          name: "บันทึกสำรองสิทธิ์การลงทะเบียนเรียน",
          url: "/tor14"
        },
        {
          tor: "TOR15",
          name: "B5-1 รายชื่อนักศึกษาเข้าชั้นเรียน (รายสัปดาห์) รูปแบบภาษาไทย",
          url: "/tor15"
        },
        {
          tor: "TOR16",
          name: "B5-2 รายชื่อนักศึกษาเข้าชั้นเรียน (รายเทอม) รูปแบบภาษาไทย",
          url: "/tor16"
        },
        {
          tor: "TOR17",
          name:
            "B5-1 รายชื่อนักศึกษาเข้าชั้นเรียน (รายสัปดาห์) รูปแบบภาษาอังกฤษ",
          url: "/tor17"
        },
        {
          tor: "TOR18",
          name: "B5-2 รายชื่อนักศึกษาเข้าชั้นเรียน (รายเทอม) รูปแบบภาษาอังกฤษ",
          url: "/tor18"
        },
        { tor: "TOR19", name: "หน้า Home", url: "/tor19" }
      ]
    };
  }
};
</script>
